var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsExcelLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_11323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 7.38952L3.88965 6.22266V14.8446C3.88965 15.2384 4.20885 15.5576 4.6026 15.5576H16.0122C16.4059 15.5576 16.7251 15.2384 16.7251 14.8446V11.668L10.5019 7.38952Z",
    fill: "#185C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5019 0H4.6026C4.20885 0 3.88965 0.319198 3.88965 0.712951V3.88954L10.5019 7.77908L14.0025 8.94595L16.7251 7.77908V3.88954L10.5019 0Z",
    fill: "#21A366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88965 3.88867H10.5019V7.77821H3.88965V3.88867Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M8.62205 3.11133H3.88965V12.8352H8.62205C9.01527 12.8339 9.33373 12.5155 9.33501 12.1222V3.82428C9.33373 3.43106 9.01527 3.11261 8.62205 3.11133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.2331 3.50195H3.88965V13.2258H8.2331C8.62632 13.2245 8.94477 12.9061 8.94605 12.5129V4.2149C8.94477 3.82168 8.62632 3.50323 8.2331 3.50195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.2331 3.50195H3.88965V12.4479H8.2331C8.62632 12.4466 8.94477 12.1282 8.94605 11.7349V4.2149C8.94477 3.82168 8.62632 3.50323 8.2331 3.50195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.84415 3.50195H3.88965V12.4479H7.84415C8.23737 12.4466 8.55582 12.1282 8.5571 11.7349V4.2149C8.55582 3.82168 8.23737 3.50323 7.84415 3.50195Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.712951 3.50195H7.84403C8.23779 3.50195 8.55698 3.82115 8.55698 4.2149V11.346C8.55698 11.7397 8.23779 12.0589 7.84403 12.0589H0.712951C0.319198 12.0589 0 11.7397 0 11.346V4.2149C0 3.82115 0.319198 3.50195 0.712951 3.50195Z",
    fill: "#107C41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20801 10.0961L3.70782 7.77211L2.33364 5.46094H3.43905L4.18895 6.93896C4.25819 7.07937 4.30564 7.18361 4.33131 7.25246H4.34103C4.3903 7.14044 4.44216 7.03166 4.49661 6.92612L5.29825 5.46172H6.31303L4.90384 7.75927L6.34882 10.0961H5.26908L4.40288 8.47378C4.36208 8.40475 4.32745 8.33225 4.29942 8.25713H4.28659C4.26121 8.33073 4.22755 8.40119 4.18623 8.46717L3.29436 10.0961H2.20801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.012 0H10.5017V3.88954H16.725V0.712951C16.725 0.319198 16.4058 0 16.012 0Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5017 7.7793H16.725V11.6688H10.5017V7.7793Z",
    fill: "#107C41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_11323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.725,
    height: 15.5582,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsExcelLogo);
export default __webpack_public_path__ + "static/media/ms_excel_logo.fe09028a17a7dcd2001c887acaefedcb.svg";
export { ForwardRef as ReactComponent };